import "./App.css";
import Navbar from "./Components/Navbar";
import AllRoutes from "./Components/AllRoutes";

function App() {
  return (
    <div className="App AppFont">
      <Navbar />
      <AllRoutes />
    </div>
  );
}

export default App;
